// source: witbooking/loyalty/organization/v1/organization_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var google_type_money_pb = require('../../../../google/type/money_pb.js');
goog.object.extend(proto, google_type_money_pb);
var witbooking_backoffice_common_common_pb = require('../../../../witbooking/backoffice/common/common_pb.js');
goog.object.extend(proto, witbooking_backoffice_common_common_pb);
goog.exportSymbol('proto.witbooking.loyalty.organization.v1.Agency', null, global);
goog.exportSymbol('proto.witbooking.loyalty.organization.v1.Company', null, global);
goog.exportSymbol('proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.organization.v1.Dummy', null, global);
goog.exportSymbol('proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.organization.v1.GetOrganizationRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.organization.v1.GetOrganizationResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.organization.v1.Organization', null, global);
goog.exportSymbol('proto.witbooking.loyalty.organization.v1.Organization.OrganizationCase', null, global);
goog.exportSymbol('proto.witbooking.loyalty.organization.v1.OrganizationUpdate', null, global);
goog.exportSymbol('proto.witbooking.loyalty.organization.v1.OrganizationUpdate.OrganizationCase', null, global);
goog.exportSymbol('proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.organization.v1.GetOrganizationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.organization.v1.GetOrganizationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.organization.v1.GetOrganizationRequest.displayName = 'proto.witbooking.loyalty.organization.v1.GetOrganizationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.organization.v1.GetOrganizationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.organization.v1.GetOrganizationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.organization.v1.GetOrganizationResponse.displayName = 'proto.witbooking.loyalty.organization.v1.GetOrganizationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest.displayName = 'proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.displayName = 'proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest.displayName = 'proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse.displayName = 'proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest.displayName = 'proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse.displayName = 'proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest.displayName = 'proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse.displayName = 'proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.organization.v1.Organization = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.loyalty.organization.v1.Organization.repeatedFields_, proto.witbooking.loyalty.organization.v1.Organization.oneofGroups_);
};
goog.inherits(proto.witbooking.loyalty.organization.v1.Organization, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.organization.v1.Organization.displayName = 'proto.witbooking.loyalty.organization.v1.Organization';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.loyalty.organization.v1.OrganizationUpdate.repeatedFields_, proto.witbooking.loyalty.organization.v1.OrganizationUpdate.oneofGroups_);
};
goog.inherits(proto.witbooking.loyalty.organization.v1.OrganizationUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.organization.v1.OrganizationUpdate.displayName = 'proto.witbooking.loyalty.organization.v1.OrganizationUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.organization.v1.Company = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.organization.v1.Company, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.organization.v1.Company.displayName = 'proto.witbooking.loyalty.organization.v1.Company';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.organization.v1.Agency = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.organization.v1.Agency, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.organization.v1.Agency.displayName = 'proto.witbooking.loyalty.organization.v1.Agency';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.organization.v1.Dummy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.organization.v1.Dummy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.organization.v1.Dummy.displayName = 'proto.witbooking.loyalty.organization.v1.Dummy';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.organization.v1.GetOrganizationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.organization.v1.GetOrganizationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.organization.v1.GetOrganizationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.GetOrganizationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    brandId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.organization.v1.GetOrganizationRequest}
 */
proto.witbooking.loyalty.organization.v1.GetOrganizationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.organization.v1.GetOrganizationRequest;
  return proto.witbooking.loyalty.organization.v1.GetOrganizationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.organization.v1.GetOrganizationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.organization.v1.GetOrganizationRequest}
 */
proto.witbooking.loyalty.organization.v1.GetOrganizationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.organization.v1.GetOrganizationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.organization.v1.GetOrganizationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.organization.v1.GetOrganizationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.GetOrganizationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBrandId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.GetOrganizationRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.GetOrganizationRequest} returns this
 */
proto.witbooking.loyalty.organization.v1.GetOrganizationRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string brand_id = 2;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.GetOrganizationRequest.prototype.getBrandId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.GetOrganizationRequest} returns this
 */
proto.witbooking.loyalty.organization.v1.GetOrganizationRequest.prototype.setBrandId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.organization.v1.GetOrganizationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.organization.v1.GetOrganizationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.organization.v1.GetOrganizationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.GetOrganizationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    organization: (f = msg.getOrganization()) && proto.witbooking.loyalty.organization.v1.Organization.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.organization.v1.GetOrganizationResponse}
 */
proto.witbooking.loyalty.organization.v1.GetOrganizationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.organization.v1.GetOrganizationResponse;
  return proto.witbooking.loyalty.organization.v1.GetOrganizationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.organization.v1.GetOrganizationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.organization.v1.GetOrganizationResponse}
 */
proto.witbooking.loyalty.organization.v1.GetOrganizationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.loyalty.organization.v1.Organization;
      reader.readMessage(value,proto.witbooking.loyalty.organization.v1.Organization.deserializeBinaryFromReader);
      msg.setOrganization(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.organization.v1.GetOrganizationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.organization.v1.GetOrganizationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.organization.v1.GetOrganizationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.GetOrganizationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganization();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.loyalty.organization.v1.Organization.serializeBinaryToWriter
    );
  }
};


/**
 * optional Organization organization = 1;
 * @return {?proto.witbooking.loyalty.organization.v1.Organization}
 */
proto.witbooking.loyalty.organization.v1.GetOrganizationResponse.prototype.getOrganization = function() {
  return /** @type{?proto.witbooking.loyalty.organization.v1.Organization} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.organization.v1.Organization, 1));
};


/**
 * @param {?proto.witbooking.loyalty.organization.v1.Organization|undefined} value
 * @return {!proto.witbooking.loyalty.organization.v1.GetOrganizationResponse} returns this
*/
proto.witbooking.loyalty.organization.v1.GetOrganizationResponse.prototype.setOrganization = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.organization.v1.GetOrganizationResponse} returns this
 */
proto.witbooking.loyalty.organization.v1.GetOrganizationResponse.prototype.clearOrganization = function() {
  return this.setOrganization(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.organization.v1.GetOrganizationResponse.prototype.hasOrganization = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    filtersMap: (f = msg.getFiltersMap()) ? f.toObject(includeInstance, undefined) : [],
    pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest}
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest;
  return proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest}
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandId(value);
      break;
    case 2:
      var value = msg.getFiltersMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFiltersMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string brand_id = 1;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest.prototype.getBrandId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest} returns this
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest.prototype.setBrandId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * map<string, string> filters = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest.prototype.getFiltersMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest} returns this
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest.prototype.clearFiltersMap = function() {
  this.getFiltersMap().clear();
  return this;};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest} returns this
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 page_number = 4;
 * @return {number}
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest} returns this
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    organizationsList: jspb.Message.toObjectList(msg.getOrganizationsList(),
    proto.witbooking.loyalty.organization.v1.Organization.toObject, includeInstance),
    pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    totalElements: jspb.Message.getFieldWithDefault(msg, 3, 0),
    totalPages: jspb.Message.getFieldWithDefault(msg, 4, 0),
    first: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    last: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse}
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse;
  return proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse}
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.loyalty.organization.v1.Organization;
      reader.readMessage(value,proto.witbooking.loyalty.organization.v1.Organization.deserializeBinaryFromReader);
      msg.addOrganizations(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalElements(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalPages(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFirst(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLast(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganizationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.loyalty.organization.v1.Organization.serializeBinaryToWriter
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTotalElements();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTotalPages();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getFirst();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getLast();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * repeated Organization organizations = 1;
 * @return {!Array<!proto.witbooking.loyalty.organization.v1.Organization>}
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.prototype.getOrganizationsList = function() {
  return /** @type{!Array<!proto.witbooking.loyalty.organization.v1.Organization>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.loyalty.organization.v1.Organization, 1));
};


/**
 * @param {!Array<!proto.witbooking.loyalty.organization.v1.Organization>} value
 * @return {!proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse} returns this
*/
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.prototype.setOrganizationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.loyalty.organization.v1.Organization=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.loyalty.organization.v1.Organization}
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.prototype.addOrganizations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.loyalty.organization.v1.Organization, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse} returns this
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.prototype.clearOrganizationsList = function() {
  return this.setOrganizationsList([]);
};


/**
 * optional int32 page_size = 2;
 * @return {number}
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse} returns this
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 total_elements = 3;
 * @return {number}
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.prototype.getTotalElements = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse} returns this
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.prototype.setTotalElements = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 total_pages = 4;
 * @return {number}
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.prototype.getTotalPages = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse} returns this
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.prototype.setTotalPages = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool first = 5;
 * @return {boolean}
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.prototype.getFirst = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse} returns this
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.prototype.setFirst = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool last = 6;
 * @return {boolean}
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.prototype.getLast = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse} returns this
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.prototype.setLast = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional int32 page_number = 7;
 * @return {number}
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse} returns this
 */
proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    organization: (f = msg.getOrganization()) && proto.witbooking.loyalty.organization.v1.Organization.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest}
 */
proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest;
  return proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest}
 */
proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.loyalty.organization.v1.Organization;
      reader.readMessage(value,proto.witbooking.loyalty.organization.v1.Organization.deserializeBinaryFromReader);
      msg.setOrganization(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganization();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.loyalty.organization.v1.Organization.serializeBinaryToWriter
    );
  }
};


/**
 * optional Organization organization = 1;
 * @return {?proto.witbooking.loyalty.organization.v1.Organization}
 */
proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest.prototype.getOrganization = function() {
  return /** @type{?proto.witbooking.loyalty.organization.v1.Organization} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.organization.v1.Organization, 1));
};


/**
 * @param {?proto.witbooking.loyalty.organization.v1.Organization|undefined} value
 * @return {!proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest} returns this
*/
proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest.prototype.setOrganization = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest} returns this
 */
proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest.prototype.clearOrganization = function() {
  return this.setOrganization(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest.prototype.hasOrganization = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse}
 */
proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse;
  return proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse}
 */
proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    organization: (f = msg.getOrganization()) && proto.witbooking.loyalty.organization.v1.OrganizationUpdate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest}
 */
proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest;
  return proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest}
 */
proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.loyalty.organization.v1.OrganizationUpdate;
      reader.readMessage(value,proto.witbooking.loyalty.organization.v1.OrganizationUpdate.deserializeBinaryFromReader);
      msg.setOrganization(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganization();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.loyalty.organization.v1.OrganizationUpdate.serializeBinaryToWriter
    );
  }
};


/**
 * optional OrganizationUpdate organization = 1;
 * @return {?proto.witbooking.loyalty.organization.v1.OrganizationUpdate}
 */
proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest.prototype.getOrganization = function() {
  return /** @type{?proto.witbooking.loyalty.organization.v1.OrganizationUpdate} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.organization.v1.OrganizationUpdate, 1));
};


/**
 * @param {?proto.witbooking.loyalty.organization.v1.OrganizationUpdate|undefined} value
 * @return {!proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest} returns this
*/
proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest.prototype.setOrganization = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest} returns this
 */
proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest.prototype.clearOrganization = function() {
  return this.setOrganization(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest.prototype.hasOrganization = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse}
 */
proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse;
  return proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse}
 */
proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    brandId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest}
 */
proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest;
  return proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest}
 */
proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBrandId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest} returns this
 */
proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string brand_id = 2;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest.prototype.getBrandId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest} returns this
 */
proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest.prototype.setBrandId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse}
 */
proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse;
  return proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse}
 */
proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.loyalty.organization.v1.Organization.repeatedFields_ = [9,10];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.loyalty.organization.v1.Organization.oneofGroups_ = [[7,8]];

/**
 * @enum {number}
 */
proto.witbooking.loyalty.organization.v1.Organization.OrganizationCase = {
  ORGANIZATION_NOT_SET: 0,
  COMPANY: 7,
  AGENCY: 8
};

/**
 * @return {proto.witbooking.loyalty.organization.v1.Organization.OrganizationCase}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.getOrganizationCase = function() {
  return /** @type {proto.witbooking.loyalty.organization.v1.Organization.OrganizationCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.loyalty.organization.v1.Organization.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.organization.v1.Organization.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.organization.v1.Organization} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.Organization.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    brandId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 3, ""),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    description: jspb.Message.getFieldWithDefault(msg, 5, ""),
    legalIdentifier: jspb.Message.getFieldWithDefault(msg, 6, ""),
    company: (f = msg.getCompany()) && proto.witbooking.loyalty.organization.v1.Company.toObject(includeInstance, f),
    agency: (f = msg.getAgency()) && proto.witbooking.loyalty.organization.v1.Agency.toObject(includeInstance, f),
    tagsList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
    tiersList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
    location: (f = msg.getLocation()) && witbooking_backoffice_common_common_pb.Localizable.toObject(includeInstance, f),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    inUse: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    phoneNumber: jspb.Message.getFieldWithDefault(msg, 15, ""),
    emailAddress: jspb.Message.getFieldWithDefault(msg, 16, ""),
    parentId: jspb.Message.getFieldWithDefault(msg, 17, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.organization.v1.Organization}
 */
proto.witbooking.loyalty.organization.v1.Organization.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.organization.v1.Organization;
  return proto.witbooking.loyalty.organization.v1.Organization.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.organization.v1.Organization} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.organization.v1.Organization}
 */
proto.witbooking.loyalty.organization.v1.Organization.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegalIdentifier(value);
      break;
    case 7:
      var value = new proto.witbooking.loyalty.organization.v1.Company;
      reader.readMessage(value,proto.witbooking.loyalty.organization.v1.Company.deserializeBinaryFromReader);
      msg.setCompany(value);
      break;
    case 8:
      var value = new proto.witbooking.loyalty.organization.v1.Agency;
      reader.readMessage(value,proto.witbooking.loyalty.organization.v1.Agency.deserializeBinaryFromReader);
      msg.setAgency(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addTiers(value);
      break;
    case 11:
      var value = new witbooking_backoffice_common_common_pb.Localizable;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.Localizable.deserializeBinaryFromReader);
      msg.setLocation(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 13:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInUse(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneNumber(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailAddress(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.organization.v1.Organization.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.organization.v1.Organization} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.Organization.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBrandId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLegalIdentifier();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCompany();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.witbooking.loyalty.organization.v1.Company.serializeBinaryToWriter
    );
  }
  f = message.getAgency();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.witbooking.loyalty.organization.v1.Agency.serializeBinaryToWriter
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
  f = message.getTiersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getLocation();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      witbooking_backoffice_common_common_pb.Localizable.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getInUse();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getPhoneNumber();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getEmailAddress();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getParentId();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string brand_id = 2;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.getBrandId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.setBrandId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ticker = 3;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string description = 5;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string legal_identifier = 6;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.getLegalIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.setLegalIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional Company company = 7;
 * @return {?proto.witbooking.loyalty.organization.v1.Company}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.getCompany = function() {
  return /** @type{?proto.witbooking.loyalty.organization.v1.Company} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.organization.v1.Company, 7));
};


/**
 * @param {?proto.witbooking.loyalty.organization.v1.Company|undefined} value
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
*/
proto.witbooking.loyalty.organization.v1.Organization.prototype.setCompany = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.witbooking.loyalty.organization.v1.Organization.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.clearCompany = function() {
  return this.setCompany(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.hasCompany = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Agency agency = 8;
 * @return {?proto.witbooking.loyalty.organization.v1.Agency}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.getAgency = function() {
  return /** @type{?proto.witbooking.loyalty.organization.v1.Agency} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.organization.v1.Agency, 8));
};


/**
 * @param {?proto.witbooking.loyalty.organization.v1.Agency|undefined} value
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
*/
proto.witbooking.loyalty.organization.v1.Organization.prototype.setAgency = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.witbooking.loyalty.organization.v1.Organization.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.clearAgency = function() {
  return this.setAgency(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.hasAgency = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated string tags = 9;
 * @return {!Array<string>}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * repeated string tiers = 10;
 * @return {!Array<string>}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.getTiersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.setTiersList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.addTiers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.clearTiersList = function() {
  return this.setTiersList([]);
};


/**
 * optional witbooking.backoffice.common.Localizable location = 11;
 * @return {?proto.witbooking.backoffice.common.Localizable}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.getLocation = function() {
  return /** @type{?proto.witbooking.backoffice.common.Localizable} */ (
    jspb.Message.getWrapperField(this, witbooking_backoffice_common_common_pb.Localizable, 11));
};


/**
 * @param {?proto.witbooking.backoffice.common.Localizable|undefined} value
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
*/
proto.witbooking.loyalty.organization.v1.Organization.prototype.setLocation = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.clearLocation = function() {
  return this.setLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.hasLocation = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
*/
proto.witbooking.loyalty.organization.v1.Organization.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
*/
proto.witbooking.loyalty.organization.v1.Organization.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional bool in_use = 14;
 * @return {boolean}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.getInUse = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.setInUse = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional string phone_number = 15;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.getPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string email_address = 16;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.getEmailAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.setEmailAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string parent_id = 17;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.getParentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.Organization} returns this
 */
proto.witbooking.loyalty.organization.v1.Organization.prototype.setParentId = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.repeatedFields_ = [9,10];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.oneofGroups_ = [[7,8]];

/**
 * @enum {number}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.OrganizationCase = {
  ORGANIZATION_NOT_SET: 0,
  COMPANY: 7,
  AGENCY: 8
};

/**
 * @return {proto.witbooking.loyalty.organization.v1.OrganizationUpdate.OrganizationCase}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.getOrganizationCase = function() {
  return /** @type {proto.witbooking.loyalty.organization.v1.OrganizationUpdate.OrganizationCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.loyalty.organization.v1.OrganizationUpdate.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.organization.v1.OrganizationUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    brandId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    description: jspb.Message.getFieldWithDefault(msg, 5, ""),
    legalIdentifier: jspb.Message.getFieldWithDefault(msg, 6, ""),
    company: (f = msg.getCompany()) && proto.witbooking.loyalty.organization.v1.Company.toObject(includeInstance, f),
    agency: (f = msg.getAgency()) && proto.witbooking.loyalty.organization.v1.Agency.toObject(includeInstance, f),
    tagsList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
    tiersList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
    location: (f = msg.getLocation()) && witbooking_backoffice_common_common_pb.Localizable.toObject(includeInstance, f),
    emailAddress: jspb.Message.getFieldWithDefault(msg, 12, ""),
    phoneNumber: jspb.Message.getFieldWithDefault(msg, 13, ""),
    parentId: (f = msg.getParentId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.organization.v1.OrganizationUpdate;
  return proto.witbooking.loyalty.organization.v1.OrganizationUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegalIdentifier(value);
      break;
    case 7:
      var value = new proto.witbooking.loyalty.organization.v1.Company;
      reader.readMessage(value,proto.witbooking.loyalty.organization.v1.Company.deserializeBinaryFromReader);
      msg.setCompany(value);
      break;
    case 8:
      var value = new proto.witbooking.loyalty.organization.v1.Agency;
      reader.readMessage(value,proto.witbooking.loyalty.organization.v1.Agency.deserializeBinaryFromReader);
      msg.setAgency(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addTiers(value);
      break;
    case 11:
      var value = new witbooking_backoffice_common_common_pb.Localizable;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.Localizable.deserializeBinaryFromReader);
      msg.setLocation(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailAddress(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneNumber(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setParentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.organization.v1.OrganizationUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBrandId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLegalIdentifier();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCompany();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.witbooking.loyalty.organization.v1.Company.serializeBinaryToWriter
    );
  }
  f = message.getAgency();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.witbooking.loyalty.organization.v1.Agency.serializeBinaryToWriter
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
  f = message.getTiersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getLocation();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      witbooking_backoffice_common_common_pb.Localizable.serializeBinaryToWriter
    );
  }
  f = message.getEmailAddress();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getPhoneNumber();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getParentId();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} returns this
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string brand_id = 2;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.getBrandId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} returns this
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.setBrandId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} returns this
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string description = 5;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} returns this
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string legal_identifier = 6;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.getLegalIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} returns this
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.setLegalIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional Company company = 7;
 * @return {?proto.witbooking.loyalty.organization.v1.Company}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.getCompany = function() {
  return /** @type{?proto.witbooking.loyalty.organization.v1.Company} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.organization.v1.Company, 7));
};


/**
 * @param {?proto.witbooking.loyalty.organization.v1.Company|undefined} value
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} returns this
*/
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.setCompany = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.witbooking.loyalty.organization.v1.OrganizationUpdate.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} returns this
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.clearCompany = function() {
  return this.setCompany(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.hasCompany = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Agency agency = 8;
 * @return {?proto.witbooking.loyalty.organization.v1.Agency}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.getAgency = function() {
  return /** @type{?proto.witbooking.loyalty.organization.v1.Agency} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.organization.v1.Agency, 8));
};


/**
 * @param {?proto.witbooking.loyalty.organization.v1.Agency|undefined} value
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} returns this
*/
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.setAgency = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.witbooking.loyalty.organization.v1.OrganizationUpdate.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} returns this
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.clearAgency = function() {
  return this.setAgency(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.hasAgency = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated string tags = 9;
 * @return {!Array<string>}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} returns this
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} returns this
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} returns this
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * repeated string tiers = 10;
 * @return {!Array<string>}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.getTiersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} returns this
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.setTiersList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} returns this
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.addTiers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} returns this
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.clearTiersList = function() {
  return this.setTiersList([]);
};


/**
 * optional witbooking.backoffice.common.Localizable location = 11;
 * @return {?proto.witbooking.backoffice.common.Localizable}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.getLocation = function() {
  return /** @type{?proto.witbooking.backoffice.common.Localizable} */ (
    jspb.Message.getWrapperField(this, witbooking_backoffice_common_common_pb.Localizable, 11));
};


/**
 * @param {?proto.witbooking.backoffice.common.Localizable|undefined} value
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} returns this
*/
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.setLocation = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} returns this
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.clearLocation = function() {
  return this.setLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.hasLocation = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string email_address = 12;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.getEmailAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} returns this
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.setEmailAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string phone_number = 13;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.getPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} returns this
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional google.protobuf.StringValue parent_id = 14;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.getParentId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 14));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} returns this
*/
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.setParentId = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.organization.v1.OrganizationUpdate} returns this
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.clearParentId = function() {
  return this.setParentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.organization.v1.OrganizationUpdate.prototype.hasParentId = function() {
  return jspb.Message.getField(this, 14) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.organization.v1.Company.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.organization.v1.Company.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.organization.v1.Company} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.Company.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.organization.v1.Company}
 */
proto.witbooking.loyalty.organization.v1.Company.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.organization.v1.Company;
  return proto.witbooking.loyalty.organization.v1.Company.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.organization.v1.Company} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.organization.v1.Company}
 */
proto.witbooking.loyalty.organization.v1.Company.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.organization.v1.Company.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.organization.v1.Company.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.organization.v1.Company} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.Company.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.organization.v1.Agency.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.organization.v1.Agency.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.organization.v1.Agency} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.Agency.toObject = function(includeInstance, msg) {
  var f, obj = {
    iata: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.organization.v1.Agency}
 */
proto.witbooking.loyalty.organization.v1.Agency.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.organization.v1.Agency;
  return proto.witbooking.loyalty.organization.v1.Agency.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.organization.v1.Agency} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.organization.v1.Agency}
 */
proto.witbooking.loyalty.organization.v1.Agency.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.organization.v1.Agency.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.organization.v1.Agency.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.organization.v1.Agency} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.Agency.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIata();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string iata = 1;
 * @return {string}
 */
proto.witbooking.loyalty.organization.v1.Agency.prototype.getIata = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.organization.v1.Agency} returns this
 */
proto.witbooking.loyalty.organization.v1.Agency.prototype.setIata = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.organization.v1.Dummy.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.organization.v1.Dummy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.organization.v1.Dummy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.Dummy.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.organization.v1.Dummy}
 */
proto.witbooking.loyalty.organization.v1.Dummy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.organization.v1.Dummy;
  return proto.witbooking.loyalty.organization.v1.Dummy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.organization.v1.Dummy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.organization.v1.Dummy}
 */
proto.witbooking.loyalty.organization.v1.Dummy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.organization.v1.Dummy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.organization.v1.Dummy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.organization.v1.Dummy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.organization.v1.Dummy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.witbooking.loyalty.organization.v1);
